import { useMediaQuery } from '@mui/material'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { campaignSlice } from '../reducers'

const useCampaignList = () => {
  const campaign = useSelector(campaignSlice.selectors.campaignData)

  const hideLeftBanner = useMediaQuery('(max-width:1140px)') || !campaign

  const listColumns = useMemo(() => {
    if (!hideLeftBanner) {
      return { xs: 12, sm: 8, md: 6, lg: 4, xl: 4 }
    }

    return { xs: 12, sm: 6, md: 4, lg: 3, xl: 3 }
  }, [hideLeftBanner])

  return { hideLeftBanner, listColumns }
}

export default useCampaignList
